import { SET_PRICING_PLANS } from 'states/actions/plans';
import {
  CLEAR_DISCOUNT_ERROR,
  FETCH_PLANS,
  SET_DISCOUNT_ERROR,
  SET_DISCOUNT_LOADING,
  SET_PALNS_AND_DISCOUNT,
  SET_PALNS_WITHOUT_DISCOUNT,
  UPGRADE_MODAL_CLOSE,
  UPGRADE_MODAL_OPEN,
} from '../constants';

const initialState = {
  plans: [],
  discount: undefined,
  discountLoading: undefined,
  discountError: undefined,
  upgradeModal: {
    show: false,
    gaEventTrackingInfo: undefined,
    permissionKey: undefined,
  },
};

export const plansReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PLANS:
      return {
        ...state,
        plans: action?.payload,
      };
    case SET_DISCOUNT_LOADING:
      return {
        ...state,
        discountError: undefined,
        discountLoading: action?.payload,
      };
    case SET_PALNS_WITHOUT_DISCOUNT:
      return {
        ...state,
        discount: undefined,
        discountLoading: false,
        discountError: undefined,
        plans: action?.payload,
      };
    case SET_PALNS_AND_DISCOUNT:
      return {
        ...state,
        ...action?.payload,
        discountLoading: false,
        discountError: undefined,
      };
    case SET_DISCOUNT_ERROR:
      return {
        ...state,
        discountLoading: false,
        discountError: action?.payload,
      };
    case CLEAR_DISCOUNT_ERROR:
      return {
        ...state,
        discountError: undefined,
      };
    case UPGRADE_MODAL_OPEN:
      return {
        ...state,
        upgradeModal: {
          ...action?.payload,
          show: true,
        },
      };
    case UPGRADE_MODAL_CLOSE:
      return {
        ...state,
        upgradeModal: {
          show: false,
          gaEventTrackingInfo: undefined,
          permissionKey: undefined,
        },
      };
    default:
      return state;
  }
};

const plansInitialState = { plans: [] };

export default function pricingReducer(state = plansInitialState, action) {
  switch (action.type) {
    case SET_PRICING_PLANS:
      return { ...state, plans: Array.isArray(action.payload) ? action.payload : [] };
    default:
      return state;
  }
}
